import { CheckCircle, XCircle } from 'lucide-react'

export function ToastContainer({ toasts }) {
  if (!toasts.length) return null
  return (
    <div className="toast-container">
      {toasts.map(t => (
        <div key={t.id} className={`toast toast-${t.type}`}>
          {t.type === 'success'
            ? <CheckCircle size={16} />
            : <XCircle size={16} />
          }
          {t.message}
        </div>
      ))}
    </div>
  )
}
